import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import NightlifeIcon from '@mui/icons-material/Nightlife';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import SuperscriptIcon from '@mui/icons-material/Superscript';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

export const logo = 'https://www.shutterstock.com/shutterstock/photos/2300329721/display_1500/stock-vector-amazon-logo-icon-isolated-on-transparent-background-vector-eps-2300329721.jpg';

export const categories = [
  { name: 'Trending Trailers', icon: <LocalFireDepartmentIcon />, },
  { name: 'Travel Vlogs', icon: <TravelExploreIcon/>, },
  { name: 'Hindi Music Trending', icon: <LibraryMusicIcon />, },
  { name: 'Live TV', icon: <LiveTvIcon />, },
  { name: 'Podcasts', icon: <GraphicEqIcon />, },
  { name: 'Trending Full Movies', icon: <LocalMoviesIcon />, },
  // { name: 'Bed time Melodies', icon: <MusicNoteIcon /> },
  // { name: 'Avicii', icon: <SuperscriptIcon />, },
  { name: 'Ritviz', icon: <NightlifeIcon />, },
  { name: 'Cartoons', icon: <TheaterComedyIcon />, },
  { name: 'Fireship', icon: <LocalFireDepartmentIcon />, },
  { name: 'Indian Cricket team', icon: <SportsEsportsIcon />, },
  { name: 'Favourites - AP Dhillon', icon: <FavoriteIcon/>, },
 
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'